<template>
  <div class="print-resident-modern">
    <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
      <ErrorsMessages :errors="errors" />

      <div v-show="errors.length == 0" class="print-container">
        <!-- Print Button -->
        <div class="print-actions no-print">
          <v-btn class="btn-print-modern" @click="printOut">
            <i class="fas fa-print mr-2"></i>
            IMPRIMIR RELATÓRIO
          </v-btn>
        </div>

        <!-- Print Content -->
        <div class="print-content">
          <!-- Header Section -->
          <div class="print-header" v-if="resident.id">
            <div class="header-row">
              <!-- Logo Section -->
              <div class="logo-section">
                <img
                  v-if="rest_home_logo_url"
                  class="institution-logo"
                  :src="rest_home_logo_url"
                  alt="Logo da Instituição"
                />
                <div v-else class="institution-name">
                  <strong>{{ rest_home_name }}</strong>
                </div>
              </div>

              <!-- Resident Info Section -->
              <div class="resident-header-info">
                <div class="resident-photo-section">
                  <img
                    :src="
                      resident.photo_url || require('../../assets/user.png')
                    "
                    class="resident-photo"
                    alt="Foto do Residente"
                  />
                </div>
                <div class="resident-basic-info">
                  <h2 class="resident-name">{{ resident.name }}</h2>
                  <div class="resident-details">
                    <div class="info-item">
                      <strong>Data de nascimento:</strong>
                      {{ formatDate(resident.date_of_birth, false) }} -
                      {{ getAge(resident.date_of_birth) }} anos
                    </div>
                    <div class="info-item">
                      <strong>Data de admissão:</strong>
                      {{ formatDate(resident.date_of_reception, false) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- System Logo Section -->
              <div class="system-logo-section">
                <img class="system-logo" :src="logo" alt="Logo do Sistema" />
              </div>
            </div>
          </div>

          <!-- Information Sections -->
          <div class="info-sections">
            <!-- Personal Information -->
            <div class="info-section">
              <h3 class="section-title">INFORMAÇÕES PESSOAIS</h3>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-field">
                    <label>Nome:</label>
                    <span>{{ resident.name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Gênero:</label>
                    <span>{{ resident.gender_name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Data de nascimento:</label>
                    <span>{{ formatDate(resident.date_of_birth, false) }}</span>
                  </div>
                  <div class="info-field">
                    <label>Status:</label>
                    <span>{{ resident.status_type_name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Apelido:</label>
                    <span>{{ resident.nickname }}</span>
                  </div>
                  <div class="info-field">
                    <label>Grau de dependência:</label>
                    <span>{{ resident.degree_of_dependence_name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Patologia (Doença):</label>
                    <span>{{ resident.pathology }}</span>
                  </div>
                  <div class="info-field">
                    <label>Alergias diversas:</label>
                    <span>{{ resident.miscellaneous_allergies }}</span>
                  </div>
                  <div class="info-field">
                    <label>Tipo de alimentação:</label>
                    <span>{{ resident.type_of_food }}</span>
                  </div>
                  <div class="info-field">
                    <label>Naturalidade:</label>
                    <span>{{ resident.naturalness }}</span>
                  </div>
                  <div class="info-field">
                    <label>Estado civil:</label>
                    <span>{{
                      resident.marital_status && resident.marital_status.name
                    }}</span>
                  </div>
                  <div class="info-field">
                    <label>Religião:</label>
                    <span>{{ resident.religion }}</span>
                  </div>
                  <div class="info-field">
                    <label>Profissão:</label>
                    <span>{{ resident.profession }}</span>
                  </div>
                  <div class="info-field">
                    <label>Escolaridade:</label>
                    <span>{{ resident.schooling }}</span>
                  </div>
                  <div class="info-field">
                    <label>Nome do pai:</label>
                    <span>{{ resident.fathers_name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Nome da mãe:</label>
                    <span>{{ resident.mothers_name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Cônjuge:</label>
                    <span>{{ resident.spouse }}</span>
                  </div>
                  <div class="info-field full-width">
                    <label>Observações:</label>
                    <span>{{ resident.comments }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Documents -->
            <div class="info-section">
              <h3 class="section-title">DOCUMENTOS</h3>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-field">
                    <label>CPF:</label>
                    <span>{{ resident.cpf }}</span>
                  </div>
                  <div class="info-field">
                    <label>RG:</label>
                    <span>{{ resident.rg }}</span>
                  </div>
                  <div class="info-field">
                    <label>Órgão expedidor:</label>
                    <span>{{ resident.issuing_body }}</span>
                  </div>
                  <div class="info-field">
                    <label>Data de emissão:</label>
                    <span>{{ resident.rg }}</span>
                  </div>
                  <div class="info-field">
                    <label>Número do cartão SUS:</label>
                    <span>{{ resident.SUS_card_number }}</span>
                  </div>
                  <div class="info-field">
                    <label>Número do benefício do INSS:</label>
                    <span>{{ resident.INSS_benefit_number }}</span>
                  </div>
                  <div class="info-field">
                    <label>Tipo de benefício INSS:</label>
                    <span>{{ resident.type_of_INSS_benefit }}</span>
                  </div>
                  <div class="info-field">
                    <label>Situação do benefício do INSS:</label>
                    <span>{{ resident.INSS_benefit_status }}</span>
                  </div>
                  <div class="info-field">
                    <label>Valor do benefício do INSS:</label>
                    <span>{{ formatPrice(resident.INSS_benefit_amount) }}</span>
                  </div>
                  <div class="info-field">
                    <label>Data da atualização do INSS:</label>
                    <span>{{
                      formatDate(resident.INSS_update_date, false)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address -->
            <div class="info-section">
              <h3 class="section-title">ENDEREÇO</h3>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-field">
                    <label>CEP:</label>
                    <span>{{ resident.cep }}</span>
                  </div>
                  <div class="info-field">
                    <label>Endereço:</label>
                    <span
                      >{{ resident.address }},
                      {{ resident.number_address }}</span
                    >
                  </div>
                  <div class="info-field">
                    <label>Bairro:</label>
                    <span>{{ resident.neighborhood }}</span>
                  </div>
                  <div class="info-field">
                    <label>Cidade:</label>
                    <span>{{ resident.city }}</span>
                  </div>
                  <div class="info-field">
                    <label>Estado:</label>
                    <span>{{ resident.uf && resident.uf.name }}</span>
                  </div>
                  <div class="info-field">
                    <label>Referência:</label>
                    <span>{{ resident.reference }}</span>
                  </div>
                  <div class="info-field">
                    <label>Complemento:</label>
                    <span>{{ resident.complement }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Hosting -->
            <div class="info-section">
              <h3 class="section-title">HOSPEDAGEM</h3>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-field" v-if="resident.type_of_hosting">
                    <label>Tipo de hospedagem:</label>
                    <span>
                      {{
                        resident.type_of_hosting
                          .billing_type_of_hosting_type_name
                      }}
                      {{ resident.type_of_hosting.name }} -
                      <strong
                        >Valor:
                        {{ formatPrice(resident.income_monthly_fee) }}</strong
                      >
                    </span>
                  </div>
                  <div class="info-field">
                    <label>Data da hospedagem:</label>
                    <span>{{
                      formatDate(resident.date_of_reception, false)
                    }}</span>
                  </div>
                  <div class="info-field full-width" v-if="resident.bed">
                    <label>Leito do residente:</label>
                    <span>
                      <strong>Número:</strong> {{ resident.bed.number }} -
                      <strong>Andar:</strong> {{ resident.bed.walk }} -
                      <strong>Ala/setor:</strong>
                      {{ resident.bed.ward_or_sector }} -
                      <strong>Quarto:</strong> {{ resident.bed.bedroom }}
                    </span>
                  </div>
                  <div class="info-field">
                    <label>Motivo da hospedagem:</label>
                    <span>{{ resident.reason_for_the_reception }}</span>
                  </div>
                  <div class="info-field">
                    <label>Data do encerramento do contrato:</label>
                    <span>{{
                      formatDate(resident.date_of_the_withdrawal, false)
                    }}</span>
                  </div>
                  <div class="info-field">
                    <label>Motivo do encerramento do contrato:</label>
                    <span>{{ resident.reason_for_the_withdrawal }}</span>
                  </div>
                  <div class="info-field">
                    <label>Outros motivos:</label>
                    <span>{{ resident.other_reasons }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Family Members -->
            <div
              v-if="
                resident.customer_has_resident &&
                resident.customer_has_resident.length > 0
              "
              class="info-section"
            >
              <h3 class="section-title">FAMILIARES VINCULADOS</h3>
              <div class="section-content">
                <div class="family-grid-header">
                  <div class="family-info-header">Informações do Familiar</div>
                  <div class="family-status-header">Resp. Financeiro</div>
                  <div class="family-status-header">Sacador Avalista</div>
                </div>
                <div
                  v-for="(item, key) in resident.customer_has_resident"
                  :key="key"
                  class="family-member"
                >
                  <div class="family-info">
                    <div class="family-detail">
                      <strong>Nome:</strong> {{ item.name }}
                    </div>
                    <div class="family-detail">
                      <strong>E-mail:</strong> {{ item.email }}
                    </div>
                    <div class="family-detail">
                      <strong>Grau de parentesco:</strong>
                      {{ item.type_of_customer_name }}
                    </div>
                    <div class="family-detail">
                      <strong>1º Telefone:</strong> {{ item.first_phone }}
                    </div>
                    <div class="family-detail">
                      <strong>2º Telefone:</strong> {{ item.second_phone }}
                    </div>
                  </div>
                  <div class="family-status">
                    <span
                      class="status-badge"
                      :class="
                        item.responsible_for_payment
                          ? 'status-yes'
                          : 'status-no'
                      "
                    >
                      {{ item.responsible_for_payment ? "SIM" : "NÃO" }}
                    </span>
                  </div>
                  <div class="family-status">
                    <span
                      class="status-badge"
                      :class="
                        item.guarantor === 'SIM' ? 'status-yes' : 'status-no'
                      "
                    >
                      {{ item.guarantor === "SIM" ? "SIM" : "NÃO" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Agreements -->
            <div
              v-if="resident.agreement && resident.agreement.length > 0"
              class="info-section"
            >
              <h3 class="section-title">CONVÊNIOS</h3>
              <div class="section-content">
                <div
                  v-for="(item, key) in resident.agreement"
                  :key="key"
                  class="agreement-item"
                >
                  <div class="agreement-info">
                    <div class="agreement-basic">
                      <div class="info-field">
                        <label>Nome:</label>
                        <span>{{ item.covenant_name }}</span>
                      </div>
                      <div class="info-field">
                        <label>Tipo/Nome do plano:</label>
                        <span>{{ item.type_plan_name }}</span>
                      </div>
                      <div class="info-field">
                        <label>Nome do titular:</label>
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="info-field">
                        <label>Telefone da central:</label>
                        <span>{{ item.exchange_phone }}</span>
                      </div>
                      <div class="info-field">
                        <label>Telefone:</label>
                        <span>{{ item.phone }}</span>
                      </div>
                      <div class="info-field">
                        <label>Celular:</label>
                        <span>{{ item.cell_phone }}</span>
                      </div>
                      <div class="info-field full-width">
                        <label>Observações:</label>
                        <span>{{ item.note }}</span>
                      </div>
                    </div>
                    <div class="agreement-address">
                      <div class="info-field">
                        <label>CEP:</label>
                        <span>{{ item.cep }}</span>
                      </div>
                      <div class="info-field">
                        <label>Endereço:</label>
                        <span
                          >{{ item.address }}, {{ item.number_address }}</span
                        >
                      </div>
                      <div class="info-field">
                        <label>Bairro:</label>
                        <span>{{ item.neighborhood }}</span>
                      </div>
                      <div class="info-field">
                        <label>Cidade:</label>
                        <span>{{ item.city }}</span>
                      </div>
                      <div class="info-field">
                        <label>Estado:</label>
                        <span>{{ item.uf }}</span>
                      </div>
                      <div class="info-field">
                        <label>Referência:</label>
                        <span>{{ item.reference }}</span>
                      </div>
                      <div class="info-field">
                        <label>Complemento:</label>
                        <span>{{ item.complement }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Electronic Signature -->
          <div class="signature-section">
            <div class="signature-content">
              <div class="signature-text">
                <strong>(Assinatura eletrônica)</strong>
              </div>
              <div class="signature-info">
                {{
                  professionalClassCouncilValue({
                    id: user.professional_class_council_id,
                    name: user.name,
                    profile: user.profile_name,
                    cpf: user.cpf,
                    office: user.office,
                    value: user.professional_class_council_value,
                  })
                }}
              </div>
              <div class="signature-date">
                {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
              </div>
            </div>
          </div>
        </div>

        <!-- Bottom Print Button -->
        <div class="print-actions no-print">
          <v-btn class="btn-print-modern" @click="printOut">
            <i class="fas fa-print mr-2"></i>
            IMPRIMIR RELATÓRIO
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import api from "../../services/api";
import { getAge } from "../../lib/getAgeByDate";
import {
  formatDate,
  formatPrice,
  professionalClassCouncilValue,
} from "../../lib/format";
import routes from "../../routes";
import moment from "moment";
import { userData } from "../../lib/functions";

export default {
  name: "PrintResident",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      rest_home_id: "",
      user: {},
      resident: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    getAge,
    formatDate,
    formatPrice,
    professionalClassCouncilValue,
    async retrieve() {
      const { id } = routes.history.current.params;
      this.id = id;

      const { rest_home_id, user, logo, permissions } = userData();
      this.user = user;
      this.rest_home_id = rest_home_id;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;
      this.permissions = permissions;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;
        const { id } = this;
        var params = { id };

        const response = await api.get("/rest-home/resident/print", { params });
        const { error, errors, resident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.resident = resident;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut: () => window.print(),
  },
};
</script>

<style scoped>
.print-resident-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 24px;
}

.loading-overlay {
  border-radius: 16px;
}

.print-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Print Actions */
.print-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.btn-print-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 16px !important;
}

.btn-print-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Print Content */
.print-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Header */
.print-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 32px;
  border-bottom: 3px solid #0f65b0;
}

.header-row {
  display: grid;
  grid-template-columns: 200px 1fr 200px;
  gap: 32px;
  align-items: center;
}

.logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.institution-logo {
  max-height: 80px;
  max-width: 180px;
  object-fit: contain;
}

.institution-name {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
}

.resident-header-info {
  display: flex;
  align-items: center;
  gap: 24px;
}

.resident-photo-section {
  flex-shrink: 0;
}

.resident-photo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #0f65b0;
  box-shadow: 0 4px 16px rgba(15, 101, 176, 0.2);
}

.resident-basic-info {
  flex: 1;
}

.resident-name {
  margin: 0 0 12px 0;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.resident-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  color: #374151;
  font-size: 14px;
  font-weight: 500;
}

.info-item strong {
  color: #1e293b;
}

.system-logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.system-logo {
  max-height: 60px;
  max-width: 180px;
  object-fit: contain;
}

/* Information Sections */
.info-sections {
  padding: 0;
}

.info-section {
  border-bottom: 1px solid #e5e7eb;
}

.info-section:last-child {
  border-bottom: none;
}

.section-title {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white !important;
  margin: 0;
  padding: 20px 32px;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.section-content {
  padding: 32px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.info-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-field.full-width {
  grid-column: 1 / -1;
}

.info-field label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.info-field span {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
  min-height: 20px;
}

/* Family Members */
.family-grid-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 20px;
  padding: 16px 0;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 20px;
}

.family-info-header,
.family-status-header {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
}

.family-member {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 20px;
  padding: 20px 0;
  border-bottom: 1px solid #f1f5f9;
  align-items: start;
}

.family-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.family-detail {
  font-size: 14px;
  color: #374151;
}

.family-detail strong {
  color: #1e293b;
}

.family-status {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-badge {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-yes {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-no {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

/* Agreements */
.agreement-item {
  padding: 24px 0;
  border-bottom: 1px solid #f1f5f9;
}

.agreement-item:last-child {
  border-bottom: none;
}

.agreement-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.agreement-basic,
.agreement-address {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Electronic Signature */
.signature-section {
  background: #f8fafc;
  padding: 32px;
  border-top: 2px solid #e5e7eb;
}

.signature-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.signature-text {
  font-size: 16px;
  color: #1e293b;
  margin-bottom: 12px;
}

.signature-info {
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  font-weight: 500;
}

.signature-date {
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
}

/* Print Styles */
@media print {
  .print-resident-modern {
    background: white !important;
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  .print-content {
    box-shadow: none !important;
    border-radius: 0 !important;
    page-break-inside: avoid;
  }

  .info-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .section-title {
    background: #0f65b0 !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .header-row {
    grid-template-columns: 180px 1fr 180px;
    gap: 20px;
  }

  .resident-name {
    font-size: 24px;
  }

  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .family-grid-header,
  .family-member {
    grid-template-columns: 60% 20% 20%;
  }

  .agreement-info {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-row {
    grid-template-columns: 1fr;
    gap: 20px;
    text-align: center;
  }

  .resident-header-info {
    flex-direction: column;
    text-align: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .family-grid-header,
  .family-member {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .agreement-info {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .print-resident-modern {
    padding: 16px;
  }

  .print-header,
  .section-content {
    padding: 20px;
  }

  .resident-name {
    font-size: 22px;
  }

  .section-title {
    padding: 16px 20px;
    font-size: 16px;
  }
}
</style>